module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.fd2246d212571b6ea761.js");
};